const state = {
  collapse: false,
  contentHeight: 0,
  vh: 0,
  vw: 0,
  printView: false
};
const getters = {
  collapse: state => {
    return state.collapse;
  },
  contentHeight: state => {
    return state.contentHeight;
  },
  isMobile: state => {
    return state.vw < 768 ? true : false;
  },
  isPrintView: state => {
    return state.printView;
  }
};
const actions = {
  toggleMenu: ({ commit }) => {
    commit("toggleMenu");
  },
  computeViewport({ commit }) {
    commit("setViewportWidth");
    commit("setViewportHeight");
  },
  togglePrintView({ commit }) {
    commit("togglePrintView");
  }
};
const mutations = {
  toggleMenu: state => {
    state.collapse = !state.collapse;
  },
  setContentHeight: (state, payload) => {
    state.contentHeight = payload;
  },
  setViewportWidth: state => {
    var app = document.getElementById("app");
    state.vw = app.clientWidth;
  },
  setViewportHeight: state => {
    var app = document.getElementById("app");
    state.vh = app.clientHeight;
  },
  togglePrintView: state => {
    state.printView = !state.printView;
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
};
